<template>
  <search-custom-dropdown
    v-model="searchInput.typeBtn.state"
    :search-input-text="searchInput.typeBtn.text"
    :is-filled="isFilled()"
    :bottom-padding="true"
    :width="50"
  >
    <template v-slot:drop-content>
      <checkbox-list-selector
        :checkbox-options="getPropertyTypes"
        :pre-selected="selectedTypes"
        @update-selection="updateCheckboxSelections($event, 'typeBtn', 'All Types')"
      />
      <template v-if="searchObject.searchType === 'sale'">
        <hr>
        <include-show-nav @option-changed="optionChanged" />
        <checkbox-list-selector
          :checkbox-options="searchOptions.listingOptions"
          :pre-selected="selectedListings"
          @update-selection="updateCheckboxSelections($event, 'includeBtn', 'Include')"
        />
      </template>
    </template>
  </search-custom-dropdown>
</template>

<script>
import IncludeShowNav from './IncludeShowNav.vue'
import searchLayoutHandler from '../../../mixins/searchLayoutHandler'
import { isEmpty } from '../../../../utils/generalUtils'
import { mapMutations } from 'vuex'

export default {
  components: { IncludeShowNav },
  mixins: [searchLayoutHandler],

  computed: {
    getPropertyTypes() {
      if (this.isRentType) {
        return [
          ...this.searchOptions.subPropertyOptions,
          { text: 'Apartment', value: 'Apartment' }
          // { text: 'Efficiency', value: 'efficiency' }
        ]
      } else {
        return [
          ...this.searchOptions.subPropertyOptions,
          { text: 'MultiFamily', value: 'MultiFamily' }
        ]
      }
    }
  },

  methods: {
    ...mapMutations('common', {
      setSearchIncludeType: 'SET_SEARCH_INCLUDE_TYPE'
    }),

    isFilled() {
      if (!this.isRentType) {
        if (this.lastNewQuery.query.Status.includes('Pending')) return true
        if (
          isEmpty(this.lastNewQuery.query.Foreclosure) ||
          this.lastNewQuery.query.Foreclosure === true
        ) {
          return true
        }
      }
      if (
        this.lastNewQuery.query.PropertySubType &&
        this.lastNewQuery.query.PropertySubType.length > 0
      ) {
        return true
      }
      return false
    },

    optionChanged(value) {
      let updatedForeclosure = this.lastNewQuery.query.Foreclosure
      let updatedStatus = this.lastNewQuery.query.Status
      this.setSearchIncludeType(value)
      if (!this.isRentType) {
        if (value === 0) {
          if (updatedForeclosure === true) {
            updatedForeclosure = ''
          }
          if (updatedStatus.includes('Pending')) {
            updatedStatus = 'Active,Pending'
          }
        } else {
          if (updatedForeclosure === '') {
            updatedForeclosure = true
          }
          if (updatedStatus.includes('Pending')) {
            updatedStatus = 'Pending'
          }
        }
        this.setNewRequestedQuery({
          ...this.lastNewQuery.query,
          Foreclosure: updatedForeclosure,
          Status: updatedStatus
        })
      }
      this.setPropertyTypeValues()
    }
  }
}
</script>

<style>
</style>
